import messages_en from "./translations/en.json";
import messages_my from "./translations/my.json";
import OtpMainMenu from "./menu/OtpMainMenu";
import OtpListPage from "./pages/OtpListPage";
import OtpDetailPage from "./pages/OtpDetailPage";

const DEFAULT_CONFIG = {
  "translations": [{ key: "en", messages: messages_en }, { key: "my", messages: messages_my }],
  "core.MainMenu": [OtpMainMenu],
  "core.Router": [
    { path: "otp/list", component: OtpListPage },
    { path: "otp/paymentrequest", component: OtpListPage },
    { path: "otp/detail/:id", component: OtpDetailPage },
  ]
}

export const OtpModule = (cfg) => {
  return { ...DEFAULT_CONFIG, ...cfg };
}
